export default __webpack_public_path__ + "static/media/Logo.a2b0c1a8.svg";